import { AdminUserContext, Profile } from './contexts/AdminUserContext';
import { ReactNode, useEffect, useState } from 'react';
import adminService from './utils/api-calls/adminService';
import { constants } from './constants';

export default function AdminUserProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [profile, setProfile] = useState<Profile | undefined>(undefined);
  const [isLogin, setIsLogin] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const login = (email: string, password: string) => {
    return adminService.auth(email, password).then((res) => {
      setProfile({ ...res, email });
      setIsLogin(true);
    });
  };

  const logout = () => {
    localStorage.removeItem(constants.adminTokenKey);
    localStorage.removeItem(constants.adminEmailKey);

    setProfile(undefined);
    setIsLogin(false);

    window.location.replace('#/admin/login');
  };

  useEffect(() => {
    const token = localStorage.getItem(constants.adminTokenKey);
    const email = localStorage.getItem(constants.adminEmailKey);
    if (token && email) {
      setProfile({
        token,
        email,
      });
      setIsLogin(true);
      if (/#\/admin\/login/.test(window.location.hash)) {
        window.location.replace('#/admin');
      }
    } else {
      setProfile(undefined);
    }
    setIsInitialized(true);
  }, []);

  return (
    <AdminUserContext.Provider
      value={{ profile, login, logout, isLogin, isInitialized }}
    >
      {children}
    </AdminUserContext.Provider>
  );
}
